import { createSlice } from "@reduxjs/toolkit";

// artıq media query-yə ehtiyac yoxdur
// const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;

const themeSlice = createSlice({
  name: "theme",
  initialState: {
    mode: "light",
  },
  reducers: {
    toggleTheme: (state) => {
      state.mode = state.mode === "dark" ? "light" : "dark";
    },
    setTheme: (state, action) => {
      state.mode = action.payload;
    },
  },
});

export const { toggleTheme, setTheme } = themeSlice.actions;
export default themeSlice.reducer;
